
import { defineComponent } from "vue";
import { Product } from "@/views/order-form/order-form-interfaces";

export default defineComponent({
  name: "WiFiProductList",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    products: {
      type: Array as () => Product[],
      default: () => [],
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(event: Event): void {
      if (event.target instanceof HTMLInputElement) {
        this.$emit("update:modelValue", event.target.value);
      }
    },
  },
  emits: ["update:modelValue"],
});
